import github from "../assets/images/facebook.png";
import twitter from "../assets/images/twitter.png";
import mail from "../assets/images/instgram.png";
import whatsapp from "../assets/images/linkdin.png";
function SocialMedia() {
  return (
    <ul className="flex items-center justify-center gap-2  max-lg:w-[150px]  lg:w-[fit-content] xl:max-w-[300px]">
      <li className="border border-3 border-black w-[40px] h-[40px] flex items-center justify-center rounded-full opacity-[.5]">
        <a href="https://github.com/wolfcodie" target="__blank">
          <img src={github} alt="social media logo" />
        </a>
      </li>
      <li className="border border-3 border-black w-[40px] h-[40px] flex items-center justify-center rounded-full opacity-[.5]">
        <a href="mailto:abdelkarim98elalaoui@gmil.com">
          <img src={mail} alt="social media logo" />
        </a>
      </li>
      <li className="border border-3 border-black w-[40px] h-[40px] flex items-center justify-center rounded-full opacity-[.5]">
        <a href="https://twitter.com/karimPrime98" target="__blank">
          <img src={twitter} alt="social media logo" />
        </a>
      </li>
      <li className="border border-3 border-black w-[40px] h-[40px] flex items-center justify-center rounded-full opacity-[.5]">
        <a
          href="https://api.whatsapp.com/send?phone=0659322899"
          target="__blank"
        >
          <img src={whatsapp} alt="social media logo" />
        </a>
      </li>
    </ul>
  );
}

export default SocialMedia;
